module.exports = __webpack_public_path__ + "img/hg.b4df49a7.png";